export default function collateErrors(values, props, json) {
    const { messages } = props

    if (json && json.errors) {
        const errors = {}
        json.errors.forEach(({ errorKey }) => {
            switch (errorKey) {
                case 'UNABLE_TO_CREATE_RETURN':
                    errors._error = messages.errors.returnError()
                    break
                case 'UNABLE_TO_CREATE_EXCHANGE':
                    errors._error = messages.errors.exchangeError()
                    break
                case 'CHANGE_COUTRY_NOT_ALLOWED':
                    errors._error = messages.errors.changeCountryNotAllowedError()
                    break
                case 'ERR_CREATE_RETURN_DUPLICATE_REQUEST':
                    errors._error = messages.errors.duplicateReturnError()
                    break
                case 'ORDER_NO_INVALID':
                    errors._error = messages.errors.invalidOrder()
                    break
                case 'ORDER_ITEM_INVALID':
                    errors._error = messages.errors.invalidOrderItem()
                    break
                default:
                    errors._error = messages.errors.generic()
            }
        })
        return errors
    }
    return { _error: messages.errors.global() }
}
